const INITIAL_STATE = {
  userDashs: {},
  tasks: {
    open: { list: [], total: 0 },
    charged: { list: [], total: 0 },
  },
  invoices: {
    list: [],
    total: 0,
    position: 0,
    positionFilter: 0,
  },
  paymentTickets: {
    list: [],
    total: 0,
    position: 0,
    positionFilter: 0,
  },
};

// REQUEST -> SAGA -> CHAMADA API -> REDUCER -> SUCCESS

/**
 * Types
 */
export const Types = {
  GET_DASH_DATA_REQUEST: 'dash/GET_DASH_DATA_REQUEST',
  GET_DASH_DATA_SUCCESS: 'dash/GET_DASH_DATA_SUCCESS',
  GET_TASKS_DASH_REQUEST: 'dash/GET_TASKS_DASH_REQUEST',
  GET_TASKS_DASH_SUCCESS: 'dash/GET_TASKS_DASH_SUCCESS',
  GET_PAYMENT_TICKET_DASH_REQUEST: 'dash/GET_PAYMENT_TICKET_DASH_REQUEST',
  GET_PAYMENT_TICKET_DASH_SUCCESS: 'dash/GET_PAYMENT_TICKET_DASH_SUCCESS',
  GET_INVOICES_DASH_REQUEST: 'dash/GET_INVOICES_DASH_REQUEST',
  GET_INVOICES_DASH_SUCCESS: 'dash/GET_INVOICES_DASH_SUCCESS',
};

/**
 * Reducer
 */
export default function auth(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.GET_DASH_DATA_SUCCESS:
      return { ...state, userDashs: action.payload };
    case Types.GET_TASKS_DASH_SUCCESS: {
      const { tasks: list, total, key } = action.payload;
      return { ...state, tasks: { ...state.tasks, [key]: { list, total } } };
    }
    case Types.GET_INVOICES_DASH_SUCCESS: {
      const { list, total, position, positionFilter } = action.payload;
      return { ...state, invoices: { list, total, position, positionFilter }};
    }
    case Types.GET_PAYMENT_TICKET_DASH_SUCCESS: {
      const { list, total, position, positionFilter } = action.payload;
      return { ...state, paymentTickets: { list, total, position, positionFilter }};
    }
    default:
      return state;
  }
}

/**
 * Actions Creators
 */
export const Creators = {
  getDashRequest: payload => ({
    type: Types.GET_DASH_DATA_REQUEST,
    payload,
  }),
  getDashSuccess: payload => ({
    type: Types.GET_DASH_DATA_SUCCESS,
    payload,
  }),
  getInvoiceDashRequest: payload => ({
    type: Types.GET_INVOICES_DASH_REQUEST,
    payload,
  }),
  getInvoiceDashSuccess: payload => ({
    type: Types.GET_INVOICES_DASH_SUCCESS,
    payload,
  }),
  getPaymentRequestDashRequest: payload => ({
    type: Types.GET_PAYMENT_TICKET_DASH_REQUEST,
    payload,
  }),
  getPaymentRequestDashSuccess: payload => ({
    type: Types.GET_PAYMENT_TICKET_DASH_SUCCESS,
    payload,
  }),
};
